import SlimSelect from 'slim-select';

class customSelect {
  constructor(context) {
    context.querySelectorAll('.exposed-form .form-select[multiple]').forEach(element => {
      new SlimSelect({
        select: element
      });
    });
  }
};

export default customSelect;